import { OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export class ToastRef {
    private closedSubject = new Subject<void>();
    public closed = this.closedSubject.asObservable().pipe(shareReplay(1));

    constructor(private readonly overlay: OverlayRef) {}

    public close() {
        this.overlay.dispose();
        this.closedSubject.next();
    }

    public isVisible() {
        return this.overlay && this.overlay.overlayElement;
    }

    public getPosition() {
        return this.overlay.overlayElement.getBoundingClientRect();
    }

    public setPositionStrategy(positionStrategy: PositionStrategy) {
        this.overlay.updatePositionStrategy(positionStrategy);
    }
}
